import React from 'react'
import injectSheet from 'react-jss'
import styles from './edit-dialog.styles'
import { Modal, ModalHeader, ModalFooter } from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import SlideForm from '../slide-form/slide-form'

const TextSlideEditDialog = ({
  classes,
  modalOpened,
  onClose,
  onSubmit,
  onDelete,
  title,
  text,
  html,
  updating,
  deleting
}) => (
  <Modal closeButton isOpen={modalOpened} requestClose={onClose}>
    <ModalHeader>Update text slide</ModalHeader>
    <SlideForm
      onSubmit={onSubmit}
      initialValues={{ title: title || '', text: html || '' }}
      footer={({ isValid }) => (
        <ModalFooter alignRight childrenGap>
          <Button action={onClose} tall simple>
            Cancel
          </Button>
          <Button tall type="submit" disabled={updating || !isValid}>
            {!updating && 'Save'}
            {updating && 'Saving...'}
          </Button>
        </ModalFooter>
      )}
    />
  </Modal>
)

export default injectSheet(styles)(TextSlideEditDialog)
